import { THEME_IDS } from '../services/branding';

const PROGRAM = 'PROGRAM';
const EXPERIENCE = 'EXPERIENCE';
const SOLUTION = 'SOLUTION';
const COMPANY_THEME = 'COMPANY_THEME';
const COMPANY = 'COMPANY';
const MASTER_THEME = 'MASTER_THEME';

const isCompanyThemeId = ( themeId ) => {
    return themeId && themeId !== THEME_IDS.LIGHT && themeId !== THEME_IDS.DARK;
};

export const getMostSpecificId = ( companyId, object ) => {
    if ( object.programId ) {
        return PROGRAM;
    } else if ( object.experienceId ) {
        return EXPERIENCE;
    } else if ( object.solutionId ) {
        return SOLUTION;
    } else if ( isCompanyThemeId( object.themeId ) ) { // company specific theme
        return COMPANY_THEME;
    } else if ( companyId ) { // company override on theme
        return COMPANY;
    } else { // fallback to theme
        return MASTER_THEME;
    }
};

export const getFallbackOptions = ( options ) => {
    if ( options.programId ) {
        return {
            programId: null,
            experienceId: options.experienceId,
            solutionId: options.solutionId,
            themeId: options.themeId
        };
    }
    if ( options.experienceId ) {
        return {
            programId: null,
            experienceId: null,
            solutionId: options.solutionId,
            themeId: options.themeId
        };
    }
    if ( options.solutionId ) {
        return {
            programId: null,
            experienceId: null,
            solutionId: null,
            themeId: options.themeId
        };
    }
    return {
        programId: null,
        experienceId: null,
        solutionId: null,
        themeId: null
    };
};

export const getName = ( hierarchyType ) => {
    switch ( hierarchyType ) {
        case PROGRAM:
            return 'Program';
        case EXPERIENCE:
            return 'Experience';
        case SOLUTION:
            return 'Solution';
        case COMPANY_THEME:
            return 'Company Theme';
        case COMPANY:
            return 'Company';
        default:
            return 'Master Theme';
    }
};

export const getKey = ( { auth, themeId, solutionId, experienceId, programId } ) => {
    const companyId = auth.state.claims.company_id;
    return `${ companyId || '' }.${ themeId || '' }.${ solutionId || '' }.${ experienceId || '' }.${ programId || '' }`;
};
